import React from "react";

const CancellationAndRefund = () => {
  return (
    <div
      className=" lg:w-[920px] w-[353px] mx-auto  flex flex-col gap-14 lg:py-32 py-24 justify-center items-center"
      id="refund"
    >
      <h1 className="text-[#101828] text-2xl font-bold">
        REFUND AND CANCELLATION POLICY
      </h1>
      <p>
        At Flit, we are committed to providing a seamless and reliable delivery
        experience. This Refund and Cancellation Policy outlines the terms under
        which cancellations and refunds are processed for both users (booking
        customers) and delivery partners (service providers).
      </p>
      <div className="flex flex-col gap-14 ">
        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              1. CANCELLATION POLICY
            </h3>
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  1.1 User-Initiated Cancellations (Booking Customer)
                </h3>
              </div>
              <p>
                <strong>1.1.1</strong> Before Pickup: Users may cancel an order
                at any time before the delivery partner picks up the item.
                Cancellations can be made directly through the Flit app or
                website.
                <br />
                <strong>1.1.2</strong> After Pickup: Once the delivery partner
                has picked up the item, the order cannot be canceled by the user
                under any circumstances.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                1.2 Delivery Partner-Initiated Cancellations
              </h3>
              <p>
                <strong>1.2.1</strong> Before Pickup: Delivery partners may
                cancel an assigned order before picking up the item due to
                unforeseen circumstances (e.g., vehicle breakdown, emergency).
                However, frequent cancellations may result in penalties or
                suspension from the platform.
                <br />
                <strong>1.2.2</strong> After Pickup: Once the delivery partner
                has picked up the item, they are obligated to complete the
                delivery. Failure to do so may result in penalties, bans, and
                legal action in cases of misconduct, fraud, or theft.
              </p>
            </div>
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              2. REFUND POLICY
            </h3>
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  2.1 Delivery Fee Refunds
                </h3>
              </div>
              <p>
                <strong>2.1.1</strong>{" "}
                <span className="font-medium">Non-Delivery:</span> If the
                delivery partner fails to complete the delivery due to their own
                fault (e.g., refusing to deliver, abandoning the package, or
                failing to arrive), the delivery fee will be refunded to the
                user.
                <br />
                <strong>2.1.2</strong>{" "}
                <span className="font-medium">Delivery Partner No-Show:</span>{" "}
                If the assigned delivery partner does not pick up the item
                within the estimated time and the user cancels before pickup,
                the delivery fee will not be given to the delivery partner by
                the user.
                <br />
                <strong>2.1.3</strong>{" "}
                <span className="font-medium">Partial Deliveries:</span> If the
                order is only partially fulfilled due to an error by the
                delivery partner, a pro-rated refund of the delivery fee may be
                considered at Flit's discretion.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                2.2 No Refund Situations
              </h3>
              <p>
                <strong>2.2.1</strong>{" "}
                <span className="font-medium">
                  Order Canceled by User After Pickup:
                </span>{" "}
                If the user attempts to cancel an order after the delivery
                partner has already picked up the item, no refund will be
                issued.
                <br />
                <strong>2.2.2</strong>{" "}
                <span className="font-medium">
                  Issues Related to Item Value:
                </span>{" "}
                Flit does not handle or refund the value of the items being
                delivered. Any disputes regarding lost, damaged, or incorrect
                items must be resolved directly between the user and the
                delivery partner.
                <br />
                <strong>2.2.3</strong>{" "}
                <span className="font-medium">
                  Incorrect Address or Contact Details:
                </span>{" "}
                If the delivery fails due to incorrect details provided by the
                user, no refund will be issued.
              </p>
            </div>
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              3. REFUND PROCESS
            </h3>
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  3.1 How to Request a Refund
                </h3>
              </div>
              <p>
                <strong>3.1.1</strong>{" "}
                <span className="font-medium">
                  Contact Flit Customer Support:
                </span>{" "}
                Reach out within 24 hours of the scheduled delivery time.
                <br />
                <strong>3.1.2</strong>{" "}
                <span className="font-medium">Provide Necessary Details:</span>{" "}
                Include the order number, reason for refund, and relevant
                details (e.g., delivery partner no-show, incomplete delivery).
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                3.2 Refund Approval & Processing
              </h3>
              <p>
                <strong>3.2.1</strong>{" "}
                <span className="font-medium">Investigation:</span> Flit will
                review the request and investigate whether the delivery partner
                was responsible for the failure.
                <br />
                <strong>3.2.2</strong>{" "}
                <span className="font-medium">Approval:</span> If the refund is
                approved, it will be processed within 7 business days and
                credited to the original payment method or issued as a Flit
                Wallet balance (if applicable).
                <br />
                <strong>3.2.3</strong>{" "}
                <span className="font-medium">Rejection:</span> If the request
                does not meet our refund criteria, it will be rejected, and no
                amount will be refunded.
              </p>
            </div>
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              4. EXCEPTIONS AND SPECIAL CASES
            </h3>
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  4.1 Force Majeure
                </h3>
              </div>
              <p>
                <strong>4.1.1</strong> Flit is not liable for delivery failures
                caused by external events such as natural disasters, strikes,
                governmental restrictions, or unforeseen emergencies. Refund
                decisions in such cases will be made on a case-by-case basis.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.2 Fraudulent Claims
              </h3>
              <p>
                <strong>4.2.1</strong> Users who attempt to abuse the refund
                policy by making fraudulent claims may face account suspension
                or permanent bans.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.3 Policy Amendments
              </h3>
              <p>
                <strong>4.3.1</strong> Flit reserves the right to modify or
                update this policy at any time. Users will be notified of
                significant changes via the Flit app or website.
              </p>
            </div>
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              5. CONTACT AND SUPPORT
            </h3>
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <p>
                For any issues related to cancellations or refunds, users can
                contact Flit customer support through the following channels:
              </p>
              <div className="flex flex-col gap-1">
                <p>
                  <strong>Email:</strong>
                  <a
                    href="mailto:support@goflash.in"
                    className="text-blue-600 hover:underline"
                  >
                    support@goflash.in
                  </a>
                </p>
                <p>
                  <strong>Helpline:</strong>
                  <a
                    href="tel:+917045063838"
                    className="text-blue-600 hover:underline"
                  >
                    +91 70450 63838
                  </a>
                </p>
              </div>
            </div>
          </p>
        </div>

        <p>
          By using Flit's services, users and delivery partners agree to abide
          by this Refund and Cancellation Policy.
        </p>
      </div>
    </div>
  );
};

export default CancellationAndRefund;
